import { render, staticRenderFns } from "./ReferenceCorrection.vue?vue&type=template&id=3c077009&scoped=true&"
import script from "./ReferenceCorrection.vue?vue&type=script&lang=js&"
export * from "./ReferenceCorrection.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCorrection.vue?vue&type=style&index=0&id=3c077009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c077009",
  null
  
)

export default component.exports